import React, {
  DetailedHTMLProps,
  forwardRef,
} from 'react';
import clsx from 'clsx';
import Button from 'pages/Dashboard/components/Button';
import isNil from 'lodash/isNil';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const ProviderLookupListDropdown = forwardRef(({
  children,
  className,
  inactiveConfig,
  ...props
}: DetailedHTMLProps<any, any>, ref) => {
  const {
    showInactive,
    onToggleShowInactive,
    type = 'doctor',
    count = 0,
  } = inactiveConfig ?? {};

  const Icon = showInactive ? ArrowDropUpIcon : ArrowDropDownIcon;

  return (
    <div className="h-full relative -m-2">
      <div
        {...props}
        className={clsx('!px-2 !pb-2', className)}
        ref={ref}
        role="listbox"
      >
        {children}
        {!isNil(inactiveConfig) && (
          <Button
            className="!hover:bg-transparent !font-medium !italic !opacity-80 !p-2 !max-w-none !w-full !justify-start flex gap-0.5 items-center"
            variant="text"
            onClick={onToggleShowInactive}
          >
            <Icon className="!w-4 !h-4" />
            {showInactive ? `Hide inactive ${type}s (${count})` : `Show inactive ${type}s (${count})`}
          </Button>
        )}
      </div>
    </div>
  );
});

export default ProviderLookupListDropdown;
